// This object map is used to determine when different query parameters is part of the same filter based on his URI.
const rangeFiltersQueryMap: Record<string, string> = {
  ps: '/price',
  pe: '/price',
  ys: '/year',
  ye: '/year',
  ms: '/mileage',
  me: '/mileage',
  ss: '/seats',
  se: '/seats',
  ccs: '/cubic_capacity',
  cce: '/cubic_capacity',
  lns: '/ship_length',
  lne: '/ship_length',
  szs: '/size',
  sze: '/size',
  rs: '/room',
  re: '/room',
  fls: '/floor',
  fle: '/floor',
  btrs: '/bathrooms',
  btre: '/bathrooms',
  ecs: '/energy_class',
  ece: '/energy_class',
};

export function countFilters(filters: Record<string, string>): number {
  let filtersCount = 0;

  const processedURIs = new Set();

  for (const queryParam of Object.keys(filters)) {
    const uri = rangeFiltersQueryMap[queryParam];

    // if the uri is not in the map, it means it's not a range filter, so we can count it without further checks
    if (!uri) {
      filtersCount++;
      continue;
    }

    if (processedURIs.has(uri)) {
      continue;
    }

    processedURIs.add(uri);
    filtersCount++;
  }
  return filtersCount;
}
